import React, { useMemo } from 'react';
import { computeDailyJobStats } from '../../utils/jobDayStats';
import './DailyJobProgressRing.css';

const DailyJobProgressRing = ({ jobs, size = 'md', className = '' }) => {
  const stats = useMemo(() => computeDailyJobStats(jobs), [jobs]);
  const { total, done, pending, percent } = stats;

  const dim = size === 'sm' ? 56 : size === 'lg' ? 128 : 72;
  const stroke = size === 'sm' ? 7 : size === 'lg' ? 10 : 8;
  const radius = (dim - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;

  return (
    <div className={`daily-job-ring ${size} ${className}`.trim()} title="Bugün son tarihi olan işlerin tamamlanma oranı">
      <div className="daily-job-ring-visual" style={{ width: dim, height: dim }}>
        <svg width={dim} height={dim} viewBox={`0 0 ${dim} ${dim}`} aria-hidden="true">
          <circle
            className="daily-job-ring-track"
            cx={dim / 2}
            cy={dim / 2}
            r={radius}
            strokeWidth={stroke}
            fill="none"
          />
          <circle
            className="daily-job-ring-progress"
            cx={dim / 2}
            cy={dim / 2}
            r={radius}
            strokeWidth={stroke}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={total === 0 ? circumference : offset}
            strokeLinecap="round"
            transform={`rotate(-90 ${dim / 2} ${dim / 2})`}
            style={{
              stroke: percent >= 70 ? '#2f9e6b' : percent >= 40 ? '#c9a24a' : '#d97706'
            }}
          />
        </svg>
        <div className="daily-job-ring-center">
          <span className="daily-job-ring-percent">{total === 0 ? '—' : `%${percent}`}</span>
          <span className="daily-job-ring-label">Bugün</span>
        </div>
      </div>
      <div className="daily-job-ring-meta">
        <div className="daily-job-ring-title">Günün işleri</div>
        <div className="daily-job-ring-stats">
          <span className="daily-job-ring-stat done">
            <i /> Yapılan <strong>{done}</strong>
          </span>
          <span className="daily-job-ring-stat pending">
            <i /> Yapılmayan <strong>{pending}</strong>
          </span>
        </div>
        <div className="daily-job-ring-total">{total === 0 ? 'Bugün son tarihli iş yok' : `Toplam ${total} iş`}</div>
      </div>
    </div>
  );
};

export default DailyJobProgressRing;
